// #3634 -- the ONE way a scribe screen goes to the lock screen. The inactivity
// timeout (useInactivityRedirect) and the corner padlock (AppShell) both call
// this, so they cannot drift apart again. It stashes the route the scribe was
// on (the lock screen's Resume and Admin Options' Back return there), re-locks
// the picker, and navigates to the lock screen with replace.

// R1-#144 -- stash key for the route the scribe was on when standby kicked in,
// so the standby screen can take them back.
export const RESUME_ROUTE_KEY = "scribe-fe.resumeRoute";

export const LOCK_SCREEN_PATH = "/setup";

// Stash the current route for the way back. Used on its own by the gear's
// admin-PIN path, which goes to /setup UNlocked.
export function stashResumeRoute(currentPath) {
  try {
    sessionStorage.setItem(RESUME_ROUTE_KEY, currentPath);
  } catch {
    // sessionStorage unavailable (private browsing, SSR) -- non-fatal; resume
    // falls back to the assigned class.
  }
}

export function goToLockScreen({ navigate, currentPath, lockPicker, redirectTo = LOCK_SCREEN_PATH }) {
  stashResumeRoute(currentPath);
  lockPicker?.();
  navigate(redirectTo, { replace: true });
}
